/**
 * Guided Walkthrough System (Shepherd.js)
 *
 * REMOVAL: To remove this entire feature:
 *   1. Delete the resources/js/tours/ folder
 *   2. Remove the `installTours(app)` line from resources/js/app.js
 *   3. Remove the help-page route from routes/web.php (if added)
 *   4. Remove the 'help-walkthroughs' nav entry from Aml.vue navItems
 *   5. npm uninstall shepherd.js
 *   6. (Optional) clean up `data-tour="..."` attributes — they're inert HTML
 */

import 'shepherd.js/dist/css/shepherd.css';
import './tours.css';
import { tours } from './registry.js';
import { startTour, isTourSeen, markTourSeen, resetTourSeen, cancelActiveTour, cancelIfNoAnchor } from './launcher.js';
import { ALWAYS_FIRST_TIME, AUTO_LAUNCH_ENABLED } from './config.js';
import HelpWalkthroughs from './HelpWalkthroughs.vue';

export function installTours(app) {
    // Expose helpers globally so any component can launch a tour.
    app.config.globalProperties.$tours = {
        start: (id) => startTour(id),
        cancel: () => cancelActiveTour(),
        cancelIfNoAnchor: () => cancelIfNoAnchor(),
        list: () => tours,
        isSeen: (id) => isTourSeen(id),
        markSeen: (id) => markTourSeen(id),
        reset: (id) => resetTourSeen(id),
        alwaysFirstTime: ALWAYS_FIRST_TIME,
        autoLaunchEnabled: AUTO_LAUNCH_ENABLED,
    };

    app.component('help-walkthroughs', HelpWalkthroughs);

    // Also expose on window for easy debugging from console.
    if (typeof window !== 'undefined') {
        window.$tours = app.config.globalProperties.$tours;
    }
}

export { tours, startTour, isTourSeen, markTourSeen, resetTourSeen, cancelActiveTour, cancelIfNoAnchor };
